import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icon/iconfont.css';
import './assets/icons/iconfont.css';
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min'
import BaiduMap from 'vue-baidu-map';
import {VueJsonp} from 'vue-jsonp';
import { Loading } from 'element-ui';
// import VueThermometer from 'vuejs-thermometer';
import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上
Vue.use(ElementUI);
Vue.use(VueJsonp);
// Vue.use(VueThermometer)
// Vue.use(VueJsonp)

import {
    saveAs
} from 'file-saver'

Vue.config.productionTip = false
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'FNNQb8cKcmmzhJeGgL00iqKCuXccltqR'
  })
  // v-dialogDrag: 弹窗拖拽属性
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
  
        dialogHeaderEl.style.cssText += ';cursor:move;'
        dragDom.style.cssText += ';top:0px;'
  
        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = (() => {
            if (window.document.currentStyle) {
                return (dom, attr) => dom.currentStyle[attr];
            } else {
                return (dom, attr) => getComputedStyle(dom, false)[attr];
            }
        })()
  
        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft;
            const disY = e.clientY - dialogHeaderEl.offsetTop;
  
            const screenWidth = document.body.clientWidth; // body当前宽度
            const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  
            const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
            const dragDomheight = dragDom.offsetHeight; // 对话框高度
  
            const minDragDomLeft = dragDom.offsetLeft;
            const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
  
            const minDragDomTop = dragDom.offsetTop;
            const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;
  
  
            // 获取到的值带px 正则匹配替换
            let styL = sty(dragDom, 'left');
            let styT = sty(dragDom, 'top');
  
            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (styL.includes('%')) {
                styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
            } else {
                styL = +styL.replace(/\px/g, '');
                styT = +styT.replace(/\px/g, '');
            };
  
            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离
                let left = e.clientX - disX;
                let top = e.clientY - disY;
  
                // 边界处理
                // if (-(left) > minDragDomLeft) {
                //     left = -(minDragDomLeft);
                // } else if (left > maxDragDomLeft) {
                //     left = maxDragDomLeft;
                // }
  
                // if (-(top) > minDragDomTop) {
                //     top = -(minDragDomTop);
                // } else if (top > maxDragDomTop) {
                //     top = maxDragDomTop;
                // }
  
                // 移动当前元素
                dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
            };
  
            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
    }
  })
import api from './components/api/index.js'
Vue.use(api)

import dialogMethod from './components/module/dialog/dialogMethod.js'
Vue.use(dialogMethod)

import wedoSocketServer from './components/module/wedoSocketServer/wedoSocketServer.js'
Vue.use(wedoSocketServer)

import wedoWebSocketClient from '@/components/js/webSocket/wedoWebSocketClient.js'
Vue.use(wedoWebSocketClient)

import historyTools from '@/components/module/tools/historyTools.js'
Vue.use(historyTools)

import resourcesStore from '@/cache/resourcesStore.js'
import menuStore from '@/cache/menuStore.js'
import cacheStore from '@/cache/cacheStore.js'
import userStore from '@/cache/userStore.js'
import unitStore from '@/cache/unitStore.js'
import enumStore from '@/cache/enumStore.js'
import eventStore from '@/cache/eventStore.js'
import archivesStore from '@/cache/archivesStore.js'
import deviceStore from '@/cache/deviceStore.js'
import variableStore from '@/cache/variableStore.js'
import realTimeValueStore from '@/cache/realTimeValueStore.js'
import svgStore from '@/cache/svgStore.js'
import roleStore from '@/cache/roleStore.js'
import teamAssessmentStore from '@/cache/teamAssessmentStore.js'
//事件推送
import socketStore from '@/cache/socketStore.js'
//工单
import orderStore from '@/cache/order/orderStore.js'
import orderGroupStore from '@/cache/order/orderGroupStore.js'
import actionItemStore from '@/cache/order/actionItemStore.js'
import messageStore from '@/cache/order/messageStore.js'
import workFlowStore from '@/cache/order/workFlowStore.js'
//西门子
import pileStore from '@/cache/siemens/pileStore.js'
//钱缓存
import moneyStore from '@/cache/moneyStore.js'
//采集配置缓存
import deviceCollectionStore from '@/cache/deviceCollectionStore.js'
//采集端定时遥控列表缓存
import timeRemoteControlStore from '@/cache/timeRemoteControlStore.js'
//宁波港
import ningboStore from '@/cache/projectDingZhi/ningbo/ningboStore';
//虚拟电厂
import plantStore from '@/cache/virtualPowerPlantStore.js';
new Vue({
    router,
    store: {
        resourcesStore,
        menuStore,
        cacheStore,
        userStore,
        unitStore,
        enumStore,
        eventStore,
        archivesStore,
        deviceStore,
        variableStore,
        realTimeValueStore,
        svgStore,
        roleStore,
        socketStore,
        //工单
        orderGroupStore,
        orderStore,
        actionItemStore,
        teamAssessmentStore,
        messageStore,
        workFlowStore,
        pileStore,
        moneyStore,
        deviceCollectionStore,
        timeRemoteControlStore,
        ningboStore,
        plantStore,
    },
    render: h => h(App)
}).$mount('#app')